import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {
    setFeaturesSetupDeletePopupOpened,
} from "./featuresActions";
import { getFilteredFeatures } from "./featuresFunctions";
import SvgIcons from '../Icons/SvgIcons';


const FeaturesSetupTopPanelDeleteFeatures = (props) => {
    const { selectedFeatures, setFeaturesSetupDeletePopupOpened } = props;

    const onItemClick = () => {
        setFeaturesSetupDeletePopupOpened(true);
    }

    const deleteButtonDisabled = !selectedFeatures.length;

    return (
        <div className="en-group text-center">
            <div className="en-group__title">
                Delete Features
            </div>
            <div className="en-group__buttons">
                <div className="en-panel en-panel--round en-panel--bordered">
                    <button className={"en-panel__button" + (deleteButtonDisabled ? " ui-button--disabled" : "")} onClick={onItemClick} disabled={deleteButtonDisabled}>
                        {SvgIcons.trashCan}
                    </button>
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = (store) => {
    const selectedFeaturesOnly = getFilteredFeatures(store, true, true);

    return {
        selectedFeatures: selectedFeaturesOnly,
    };
};

const mapDispatchToProps = {
    setFeaturesSetupDeletePopupOpened
};

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)
        (FeaturesSetupTopPanelDeleteFeatures)
)
